var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrendingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 8,
    fill: "url(#pattern0_1_385)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1_385",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_385",
    transform: "scale(0.025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_385",
    width: 40,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAN3SURBVHgB7VhdTttAEJ6xQ4kBqeEEDSconKDhBlSFZ1KpFbwBJ0g4QeGpoa1EeCYt6QnIEegNwgmaSigJJN7pjCOLULJ/wdAXPinx2rtrfzu7M/PtAvwn9LbXivKztcvBE6H3Yb1EIa0h4GtFsAyEHcDBqq3foxKk3bVCv5vbUQC7hFAAQCB+jih/8V5Ua7Zt70B4BIwTw4TYvY+2oqOG1XqCzC0oU9ntwpkQ044+hn1wRAAZore9XqEQzidZLQWvwXb0rdECR2Rmwd7Wu2MiKNvaEaif4IGpLTgeIrpb658IsOzSD2NsggemIpiEDJVbS8o8rXzZde3rM70Cb4JiOY5nx4rjWFImqDp3JrgAT3gTVCqs8kQVA6QCW/HMpy87Twc84eUkVx83yoi0KWUOuBWTt2YFZ4Kj6VSVNLY/BTmB8xSnUwsPAAEVwRNOBMV6iLgJTqBD/rUn12HxN6dB8ICbBSl37NIMUb3ngTRNln7RDUtpWQbe39o4exBBjnMldoiSrZ2Qi2o/6qRYSpk+iLiTlhWFTQVUMrYHC5Sisq1NSk7KvM6MBGWwYjnJPqIN+VHBJFyNXjzyXPPa40C9P3c0IidgC70iMIMoPOdLMb0PgxntujRaMI5nSqZ6lp/1+S+NKngDi+N3NwP9sjASDAPSWk9kE2f+e7qOrfcHPBEEajqCJudQRCeTJDtL+yTfygA4mDupZg79L8GXoHiv/oXYDoJhXfPC1si6g9Wo1miJvAcLeJ37W5C91xBQVUu34RFS+WiwktbHQL/ABiR/JyEK9ARjPAHT9w6at6pFBd4SaxxTCdb+wtD5o2GoS3tjkD2yBlqCHHw1nai9OG6hLIBwqavSEry5iVuT38UOkDHYGNp9ipbgYr3ZmeSBnDm81IgtN4+gWroa8xrECc6A5EfQkptFnpmOQIwEo9ppHe9pOz9Nx8H6jbZONvFRXAUDrF4cq+Atm+GOU+Svcg7TNtrD6LRhGszR4nBWggtfTy94i7k6TlKO0Wz9RAlxjq2AgVymp1uJZmOZxCcIRb7tXEfDJV24Gck0kVRJ21vwICmAw7n88AAdQ5VzoJbR9q/jFRYDomAKs91ceVK75NThH3JJNCDYi+aGS/O1RhU94uhU54PJ9GG4PPv5e/PucxEYtKkUXrIAaEsWyeeHF5h1YH/GM54QfwF8BmkPzmljlwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingIcon);
export default __webpack_public_path__ + "static/media/trending_icon.a9c4aafffc174bbc7ad0bd738f4ef1a2.svg";
export { ForwardRef as ReactComponent };